import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

const Ban = () => <FontAwesomeIcon height="16px" iconName="ban" />;
const CircleExclamation = () => (
  <FontAwesomeIcon height="16px" iconName="circle-exclamation" />
);
const CopyLink = () => <FontAwesomeIcon height="16px" iconName="copy" />;
const Delete = () => <FontAwesomeIcon height="16px" iconName="trash-can" />;
const Edit = () => <FontAwesomeIcon height="16px" iconName="pen" />;
const Pin = () => (
  <FontAwesomeIcon
    height="16px"
    iconName="thumbtack"
    iconType="solid"
    rotation="45"
  />
);
const PinHollow = () => (
  <FontAwesomeIcon height="16px" iconName="thumbtack" rotation="45" />
);

export const actionItemsIcons = {
  ban: Ban,
  circleExclamation: CircleExclamation,
  copyLink: CopyLink,
  delete: Delete,
  edit: Edit,
  pin: Pin,
  pinHollow: PinHollow,
};
